
export default {
  data() {
    return {
      focus: false,
    }
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMsg: {
      type: String,
      default: 'Pogreška!',
    },
    textarea: {
      type: Boolean,
      default: false,
    },
    required: {
      type: [Object, Boolean],
      default: false,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        if (this.type === 'date') {
          const dateToString = val.toString()
          this.$emit('input', dateToString)
        } else this.$emit('input', val)
      },
    },
  },
}
